import React, { useState } from "react";
import "../Modal.css";
import { IoIosCloudUpload } from "react-icons/io";
import { FaPlus, FaTrash } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import { createPatientAction } from "../../Actions/PatientActions/PatientAction";
import { MdCancel, MdOutlineSaveAlt } from "react-icons/md";
const PatientModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState({
    fullname: "",
    gender: "Male",
    phone: "",
    birthdate: "",
  });
  const [errors, setErrors] = useState({});

  // Validation function to check required fields with trimming
  const validate = () => {
    const errors = {};

    if (!inputValue.fullname.trim()) {
      errors.fullname = "Full name is required.";
    }

    if (!inputValue.gender.trim()) {
      errors.gender = "Gender is required.";
    }

    if (!inputValue.phone.trim()) {
      errors.phone = "Phone number is required.";
    }

    if (!inputValue.birthdate.trim()) {
      errors.birthdate = "Birthdate is required.";
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const [image, setImage] = useState([]);
  const handleAdd = (e) => {
    e.preventDefault();
    setImage([...image, ""]);
  };

  const handleRemoveInput = (e, index) => {
    const removeInput = [...image];
    removeInput.splice(index, 1);
    setImage(removeInput);
  };
  const handleChangeFileImage = (e, index) => {
    const newValue = [...image];
    newValue[index] = e.target.files[0];
    setImage(newValue);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      dispatch(
        createPatientAction(
          inputValue.fullname,
          inputValue.gender,
          inputValue.phone,
          inputValue.birthdate,
          image
        )
      );
      onClose(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div className="modal-overlay">
          <div className="modal">
            <form
              onSubmit={handleSubmit}
              className="bg-white rounded-sm shadow-md lg:w-6/12 p-6  m-auto"
            >
              <div className="grid grid-cols-2 gap-3">
                <div className="form-group">
                  <label htmlFor="fullName">Full Name</label>
                  <input
                    type="text"
                    id="fullName"
                    name="fullname"
                    placeholder="Full Name"
                    value={inputValue.fullname}
                    onChange={handleInputChange}
                    className="p-1.5 input"
                  />
                  <p className="text-red-500">
                    {errors.fullname && errors.fullname}
                  </p>
                </div>
                <div className="form-group">
                  <label htmlFor="gender">Gender</label>
                  <select
                    id="gender"
                    name="gender"
                    value={inputValue.gender}
                    onChange={handleInputChange}
                    className="p-1.5 input"
                  >
                    <option value="">Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                  <p className="text-red-500">
                    {errors.gender && errors.gender}
                  </p>
                </div>
                <div className="form-group">
                  <label htmlFor="birthdate">Birthdate</label>
                  <input
                    type="date"
                    placeholder="Birth Date"
                    name="birthdate"
                    value={inputValue.birthdate}
                    onChange={handleInputChange}
                    id="birthdate"
                    className="p-1.5 input"
                  />
                  <p className="text-red-500">
                    {errors.birthdate && errors.birthdate}
                  </p>
                </div>
                <div className="form-group">
                  <label htmlFor="phoneNumber">Phone Number</label>
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone Number"
                    value={inputValue.phone}
                    onChange={handleInputChange}
                    id="phoneNumber"
                    className="p-[0.385rem] input"
                  />
                      <p className="text-red-500">
                    {errors.phone && errors.phone}
                  </p>
                </div>
              </div>

              <div className="form-group w-full mt-2 ">
                <div onClick={handleAdd}>
                  <button className="btn-green">
                    <FaPlus />
                  </button>
                </div>
                {image.map((img, index) => {
                  return (
                    <div
                      key={index}
                      className="flex items-center w-full px-4 m-auto "
                    >
                      <label htmlFor={`doc-${index}`} className="inputFile">
                        <div className="file-container w-full">
                          <h4 className="text-base font-semibold text-center text-gray-700 w-full">
                            {img ? img.name : "Upload a file "}
                          </h4>
                          <div className="text-teal-600">
                            <IoIosCloudUpload />
                          </div>
                        </div>
                        <input
                          type="file"
                          id={`doc-${index}`}
                          // name="doc"
                          onChange={(e) => handleChangeFileImage(e, index)}
                          name={`image_${index}`}
                          hidden
                        />
                      </label>

                      <button
                        className="btn-danger py-2"
                        onClick={() => handleRemoveInput(index)}
                      >
                        <FaTrash />
                      </button>
                    </div>
                  );
                })}
              </div>

              <div className="flex gap-2 mt-2">
                <button type="submit" className="btn-indigo">
                  Save <MdOutlineSaveAlt />

                </button>
                <button
                  type="button"
                  onClick={() => onClose(false)}
                  className="btn-red "
                >
                  Cancel <MdCancel />
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default PatientModal;
